import React, { PropsWithChildren, useMemo } from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { eventConditionsPrimitiveSelector } from '../../../../../redux/selectors/builder';
import { IRowMeta } from '../../../../../redux/slices/oldBuilder';
import {
  FieldContext,
  IBasicFilterFieldsFragment,
  IEventConditionFieldsFragment,
  TagOption,
} from '../../../../../utils/apollo/graphqlSchema';
import { defaultEventInput } from '../../../../../utils/builder';
import { createTagOptionInput } from '../../../../Builder/EntitySelection/utils';
import FieldDroppableZone from '../../../../DndEntity/DndDroppableZone/FieldDroppableZone';
import { createDictionaryEntityDropzoneId } from '../../../../DndEntity/utils';
import {
  EntityDropzoneDataTypeEnum,
  IFieldEntityDropzoneDataType,
} from '../../../../DndEntity/validation';
import { EntityDropzoneType } from '../../../../QuickAccessDictionary/DictionaryTabs/types';
import { generateEventsInputByEvents } from '../../../../Builder/utils/builderUtils';
import { isNil } from 'lodash';
import * as BasicFilterViewUI from '../BasicFilterViewUI';

interface IProps {
  rowMeta: IRowMeta;
  conditionIndex: number;
  predicateIndex: number;
  filter: IBasicFilterFieldsFragment;
}

const BasicFilterConditionDroppable = ({
  rowMeta,
  conditionIndex,
  predicateIndex,
  filter,
  children,
}: PropsWithChildren<IProps>) => {
  const fieldsDropzoneId = createDictionaryEntityDropzoneId(
    EntityDropzoneType.Fields,
    rowMeta,
    `Condition-${conditionIndex}-Predicates`,
  );

  const eventConditionsSelector = useMemo(eventConditionsPrimitiveSelector, []);
  const eventConditions: IEventConditionFieldsFragment[] = useAppSelector(
    (state) => eventConditionsSelector(state, rowMeta),
  );

  const tags = [
    createTagOptionInput(TagOption.Field, {
      field: {
        func: null,
        context: FieldContext.Filter,
        events: !isNil(rowMeta.eventIndex)
          ? generateEventsInputByEvents(
              eventConditions[rowMeta.eventIndex].events,
            )
          : [defaultEventInput],
        arrayObjectContext: null,
      },
    }),
  ];

  return (
    <FieldDroppableZone
      dropzoneId={fieldsDropzoneId}
      tags={tags}
      data={
        {
          id: fieldsDropzoneId,
          type: EntityDropzoneDataTypeEnum.Fields,
          filter,
          conditionIndex,
          predicateIndex,
          rowMeta,
        } satisfies IFieldEntityDropzoneDataType
      }
      shouldFitContent
      customMessage="+ Add Filter"
    >
      <BasicFilterViewUI.Bracket>(</BasicFilterViewUI.Bracket>
      {children}
      <BasicFilterViewUI.Bracket>)</BasicFilterViewUI.Bracket>
    </FieldDroppableZone>
  );
};

export default BasicFilterConditionDroppable;
